define('widget/cookie/main',['./view/cookie'], function (CookieView) {
  return function (rootEl) {
    var view = new CookieView({
      el: rootEl
    })

    var cornerTimeout = setTimeout(view.closeCorner, 20000)
    var boxTimeout = setTimeout(view.closeBox, 5000)

    view.on('boxOpened', function () {
      clearTimeout(cornerTimeout)
      cornerTimeout = setTimeout(view.closeCorner, 20000)
      clearTimeout(boxTimeout)
      boxTimeout = setTimeout(view.closeBox, 5000)
    })
  }
})
;
